module.exports = __webpack_public_path__ + "assets/img/ch.2a3992e6.svg";